import React, { useEffect, useState } from 'react';
import { getLotImage, getLotImageStatic, preloadLotImages } from '../../utils/getLotImage';
// Styles de la mosaique de lots (grille + cartes + skeleton), definis cote Accueil et scopes
// `.accueil-*` (aucun selecteur global -> import sans fuite). Reutilises tels quels par la page
// Catalogue acheteur, pour une grille STRICTEMENT identique a celle de l'accueil.
import '../../pages/Accueil/Accueil.css';

export interface LotTechnique {
  id: number;
  code: string;
  nom: string;
}

export interface ArticlePublic {
  id: number;
  code: string;
  nom: string;
}

export interface LotTechniqueExt extends LotTechnique {
  /** Image locale (import) ou URL — prioritaire sur getLotImage() */
  customImage?: string;
  /** Catalogue statique quand le lot n'existe pas en BDD */
  staticArticles?: ArticlePublic[];
}

// Famille du lot par 1er chiffre du code : 1 = Ingenierie, 2 = Travaux, 3 = Services.
export const getLotFamille = (code: string): { label: string; cls: string } => {
  const first = String(code).trim()[0];
  if (first === '1') return { label: 'Ingénierie', cls: 'accueil-lot-card-badge--ingenierie' };
  if (first === '2') return { label: 'Travaux', cls: 'accueil-lot-card-badge--travaux' };
  if (first === '3') return { label: 'Services', cls: 'accueil-lot-card-badge--services' };
  return { label: '', cls: '' };
};

// Libelles d'affichage qui different du nom stocke en base, par code de lot.
// Renommage cote UI uniquement : la resolution d'image continue d'utiliser lot.nom.
export const LOT_LABELS: Record<string, string> = {
  '101': "Assistance à maîtrise d'ouvrage",
};

export const LotCard: React.FC<{ lot: LotTechniqueExt; onClick: () => void }> = ({ lot, onClick }) => {
  const [imgSrc, setImgSrc] = useState<string>(() => lot.customImage ?? getLotImage(lot.nom));
  const famille = getLotFamille(lot.code);
  const displayNom = LOT_LABELS[lot.code] ?? lot.nom;

  useEffect(() => {
    if (lot.customImage) return;
    preloadLotImages().then(() => setImgSrc(getLotImage(lot.nom)));
  }, [lot.nom, lot.customImage]);

  return (
    <div
      className="accueil-lot-card"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
    >
      <div className="accueil-lot-card-img-wrap">
        <img
          src={imgSrc}
          alt={displayNom}
          className="accueil-lot-card-img"
          onError={() => setImgSrc(getLotImageStatic(lot.nom))}
        />
        {famille.label && (
          <span className={`accueil-lot-card-badge ${famille.cls}`}>{famille.label}</span>
        )}
      </div>
      <div className="accueil-lot-card-body">
        <span className="accueil-lot-card-code">{lot.code}</span>
        <span className="accueil-lot-card-nom">{displayNom}</span>
      </div>
    </div>
  );
};
